import React from 'react';
import { Tooltip } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { getCountryCode, maskContactNumber } from '../../../Utils/helpers/commonhelper';
import { IconGlobe, IconMail, IconMapPin, IconPhone, IconUser } from '@tabler/icons-react';

export const ContactTooltip = ({ module_name, contact, data, customer }) => {
    const brandColor = "#7a3a5e"; // Corporate Velvet Purple
    // Modern profile card rendering engine
    const renderPreviewCard = (props) => (
        <Tooltip
            id="contact-preview-card"
            {...props}
            show={props.show?.toString()}
            className="modern-preview-tooltip"
        >
            <div
                className="p-3 rounded-4 shadow-lg border text-start"
                style={{
                    maxWidth: "440px",
                    backgroundColor: "#fff",
                    // backdropFilter: "blur(8px)",
                    borderColor: "#e2e8f0",
                    fontFamily: "inherit"
                }}
            >
                {/* PROFILE HEADER BLOCK */}
                <div className="d-flex align-items-center gap-3 pb-3 mb-3 border-bottom" style={{ borderColor: "#f1f5f9" }}>
                    <div
                        className="d-flex align-items-center justify-content-center rounded-circle fw-bold text-uppercase flex-shrink-0"
                        style={{
                            width: "42px",
                            height: "42px",
                            backgroundColor: "#fdf2f8",
                            color: brandColor,
                            fontSize: "14px",
                            letterSpacing: "0.03em"
                        }}
                    >
                        {contact.contact_full_name?.substring(0, 2).toUpperCase() || "NA"}
                    </div>
                    <div className="min-w-0">
                        <h6 className="mb-0 fw-bold text-dark text-truncate text-capitalize" style={{ fontSize: "15px", letterSpacing: "-0.01em" }}>
                            {contact.company_name || "Unmapped Entity"}
                        </h6>
                        <span className="text-muted small d-block text-truncate mt-0.5">
                            {contact.department || "No Industry Specified"}
                        </span>
                    </div>
                </div>

                {/* METADATA GRID ARCHITECTURE */}
                <div className="row g-2 mb-3">
                    <div className="col-6">
                        <div className="d-flex align-items-start gap-1.5 min-w-0">
                            <IconMapPin size={14} className="text-muted mt-0.5 flex-shrink-0" />
                            <div className="min-w-0">
                                <span className="text-muted d-block" style={{ fontSize: "10px", fontWeight: "600", letterSpacing: "0.02em" }}>CITY</span>
                                <span className="text-dark d-block text-truncate fw-medium" style={{ fontSize: "12px" }}>{contact.city_name || "-"}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="d-flex align-items-start gap-1.5 min-w-0">
                            <IconGlobe size={14} className="text-muted mt-0.5 flex-shrink-0" />
                            <div className="min-w-0">
                                <span className="text-muted d-block" style={{ fontSize: "10px", fontWeight: "600", letterSpacing: "0.02em" }}>COUNTRY</span>
                                <span className="text-dark d-block text-truncate fw-medium" style={{ fontSize: "12px" }}>{contact.country_name || "-"}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mt-2">
                        <div className="d-flex align-items-start gap-1.5 min-w-0">
                            <IconUser size={14} className="text-muted mt-0.5 flex-shrink-0" />
                            <div className="min-w-0">
                                <span className="text-muted d-block" style={{ fontSize: "10px", fontWeight: "600", letterSpacing: "0.02em" }}>ACCOUNT OWNER</span>
                                <span className="text-dark d-block text-truncate fw-semibold text-capitalize" style={{ fontSize: "12px" }}>{contact.owner_name || "-"}</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* DIRECT CHANNELS COMMUNICATION TRAY */}
                <div className="p-2 rounded-3 d-flex flex-column gap-2" style={{ backgroundColor: "#f8fafc" }}>
                    <div className="d-flex align-items-center justify-content-between gap-3 min-w-0">
                        <div className="d-flex align-items-center gap-2 text-secondary min-w-0">
                            <IconPhone size={13} stroke={2.5} className="flex-shrink-0" style={{ color: brandColor }} />
                            <span style={{ fontSize: "11px", fontWeight: "500" }}>Contact:</span>
                        </div>
                        <span className="fw-bold text-dark text-truncate text-end" style={{ fontSize: "11.5px", letterSpacing: "0.2px" }}>
                            {getCountryCode(contact)} {maskContactNumber(customer, contact.phone)}
                        </span>
                    </div>

                    <div className="d-flex align-items-center justify-content-between gap-3 min-w-0 border-top pt-2" style={{ borderColor: "#e2e8f0" }}>
                        <div className="d-flex align-items-center gap-2 text-secondary min-w-0">
                            <IconMail size={13} stroke={2.5} className="flex-shrink-0" style={{ color: brandColor }} />
                            <span style={{ fontSize: "11px", fontWeight: "500" }}>Email:</span>
                        </div>
                        <span className="fw-medium text-dark text-truncate text-end" style={{ fontSize: "11.5px" }}>
                            {contact.email || "-"}
                        </span>
                    </div>
                </div>
            </div>
        </Tooltip>
    );

    return (
        <>
            {/* Global style injector overriding default bootstrap styling block constraints smoothly */}
            <style>{`
                .modern-preview-tooltip .tooltip-inner {
                    background-color: transparent !important;
                    background : #fff;
                    opacity : 1;
                    padding: 0 !important;
                    max-width: 20rem !important;
                    min-width: 20rem !important;
                    box-shadow: none !important;
                }
                .modern-preview-tooltip .tooltip-arrow::before {
                    border-right-color: rgba(255, 255, 255, 0.98) !important;
                }
            `}</style>

            <OverlayTrigger
                placement="right"
                delay={{ show: 50, hide: 40 }}
                overlay={renderPreviewCard}
            >
                <span
                    className="d-inline-flex align-items-center gap-2 text-secondary transition-all"
                    style={{
                        cursor: "pointer",
                        letterSpacing: "0.25px",
                        fontSize: "13px",
                        fontWeight: "500"
                    }}
                >
                    {/* <span> {getCountryCode(contact)} {maskContactNumber(customer, data)}</span> */}
                    <span>{module_name === "contact" ? data ? <>
                        <IconPhone size={14} stroke={2.5} style={{ color: 'blue' }} />
                        {getCountryCode(contact)} {maskContactNumber(customer, data)}
                    </> : "-" : `${contact?.industry}`}</span>
                </span>
            </OverlayTrigger>
        </>
    );
};